import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function ShareboxFooter() {
  const { t: translate } = useTranslation();

  return (
    <Box sx={{ py: 3, textAlign: "center" }}>
      <Typography variant="caption" color="text.secondary">
        {translate("Powered by MyRent")}
      </Typography>
    </Box>
  );
}
